import type { StepProps } from './types';

const QUALIFICATIONS = ['正看護師', '准看護師', '保健師', '助産師'];

type Props = Pick<StepProps, 'formData' | 'onChange' | 'onNext'>;

export default function StepQualification({ formData, onChange, onNext }: Props) {
  const toggle = (item: string) => {
    const current = formData.qualifications;
    const updated = current.includes(item)
      ? current.filter((v) => v !== item)
      : [...current, item];
    onChange('qualifications', updated);
  };

  const handleNext = () => {
    if (formData.qualifications.length === 0) return;
    onNext();
  };

  return (
    <div>
      <p style={{ fontWeight: 700, fontSize: '15px', marginBottom: '4px', color: '#333' }}>
        Q1. 保有している資格を選んでください
      </p>
      <p style={{ fontSize: '12px', color: '#aaa', marginBottom: '14px' }}>※複数選択可</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px', marginBottom: '20px' }}>
        {QUALIFICATIONS.map((item) => {
          const selected = formData.qualifications.includes(item);
          return (
            <button
              key={item}
              type="button"
              onClick={() => toggle(item)}
              className={`choice-label${selected ? ' selected' : ''}`}
              style={{
                border: selected ? '1.5px solid #fa7c9e' : '1.5px solid #f0c8d4',
                position: 'relative',
              }}
            >
              <span>{item}</span>
              {selected && (
                <span
                  style={{
                    position: 'absolute',
                    top: '4px',
                    right: '6px',
                    fontSize: '9px',
                    fontWeight: 700,
                    color: '#fff',
                    background: '#fa7c9e',
                    borderRadius: '3px',
                    padding: '1px 5px',
                    lineHeight: 1.4,
                    letterSpacing: '0.02em',
                  }}
                  aria-label="選択中"
                >
                  選択中
                </span>
              )}
            </button>
          );
        })}
      </div>
      <p style={{ fontSize: '12px', color: '#aaa', marginBottom: '12px', textAlign: 'center' }}>
        ※複数選択可
      </p>
      <div style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '11px', color: '#ff5c73', marginBottom: '6px', fontWeight: 700 }}>完全無料！</p>
        <button
          className="btn-next"
          style={{ width: '100%', maxWidth: '300px', padding: '15px 24px', fontSize: '15px' }}
          onClick={handleNext}
          disabled={formData.qualifications.length === 0}
        >
          次のステップへ
        </button>
      </div>
    </div>
  );
}
